<template>
  <div class="row">
    <div class="col-md-10">
      <h2 style="display: inline-block;">Search</h2>
      <button
        class="btn-default btn-create"
        style="float: right;"
        v-on:click="newProvider"
      >
        Create provider
      </button>
      <p>
        Type in search query and click search to lookup providers. Click
        advanced search in order to toggle extra search options.
      </p>
      <hr />
      <div>
        <form v-on:submit.prevent="search" class="form-inline">
          <div class="form-group input-group col-sm-6">
            <span style="background: white;" class="input-group-addon"
              ><i class="fa fa-search icon"></i
            ></span>
            <div>
              <input
                style="border-right: #404040; width: 70%;"
                class="form-control "
                type="search"
                v-model="query"
              />
            </div>
            <div class="input-group-append">
              <button
                style="border: 1px solid black; border-top-left-radius: 0px; border-bottom-left-radius: 0px;"
                class="btn btn"
                type="button"
                value="Search"
                @click="search"
              >
                Search
              </button>
            </div>
          </div>
          <input
            v-if="!advancedSearchToggle"
            class="btn-search"
            type="button"
            value="Advanced Search"
            v-on:click="toggleAdvancedSearch"
          />
          <input
            v-if="advancedSearchToggle"
            class="btn-search"
            style="background-color: lightgrey;"
            type="button"
            value="Advanced Search"
            v-on:click="toggleAdvancedSearch"
          />
          <div style="display: inline-block; "></div>
          <div v-if="advancedSearchToggle" style="margin-top:15px;">
            <div style="display: inline-block;">
              <div class="dropdown">
                <button class="dropbtn btn-search advanced-search-buttons">
                  Country
                </button>
                <div class="dropdown-content">
                  <div class="modal-content" style="max-height: 400px;">
                    <div class="form-group input-group">
                      <span
                        style="background: white; border-width: 0px 0px 1px 0px; border-radius: 0px; font-size: 10px;"
                        class="input-group-addon"
                        ><i class="fa fa-search icon"></i
                      ></span>
                      <input
                        type="text"
                        style="width: 100%; margin: 0px; border-radius: 0px; border-width: 0px 0px 1px 0px;"
                        placeholder="search"
                        v-model="countrySearchQuery"
                        v-if="search"
                        class="form-group input-group"
                      />
                    </div>
                    <div
                      v-for="items in sortedDevCountriesBySearchQuery"
                      v-if="items.array.length > 0"
                    >
                      <h5 style="margin-right: 10px; float: right;">
                        {{ items.letter }}
                      </h5>
                      <input
                        v-for="item in items.array"
                        v-on:click="$store.commit('toggleCountriesParam', item)"
                        type="button"
                        :value="item.name"
                        class="grid-item small-btn-search btn-search"
                        v-bind:class="{ selected: countrySelected(item) }"
                        style="margin: 0px; border-radius:0px; width: 100%; border-width: 0px 0px 1px 0px; display: block; text-align: left;"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="dropdown">
                <button class="dropbtn btn-search advanced-search-buttons">
                  Sectors
                </button>
                <div class="dropdown-content">
                  <div class="modal-content" style="max-height: 400px;">
                    <div
                      v-for="items in sortedSectors"
                      v-if="items.array.length > 0"
                    >
                      <input
                        v-for="item in items.array"
                        v-on:click="$store.commit('toggleSectorsParam', item)"
                        type="button"
                        :value="item.name"
                        class="grid-item small-btn-search btn-search"
                        v-bind:class="{ selected: sectorSelected(item) }"
                        style="margin: 0px; border-radius:0px; width: 100%; border-width: 0px 0px 1px 0px; display: block; text-align: left;"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="dropdown">
                <button class="dropbtn btn-search advanced-search-buttons">
                  Captital Types
                </button>
                <div class="dropdown-content">
                  <div class="modal-content" style="max-height: 400px;">
                    <div
                      v-for="items in sortedCapitalTypes"
                      v-if="items.array.length > 0"
                    >
                      <input
                        v-for="item in items.array"
                        v-on:click="
                          $store.commit('toggleCapitalTypesParam', item)
                        "
                        type="button"
                        :value="item.name"
                        class="grid-item small-btn-search btn-search"
                        v-bind:class="{ selected: capitalTypeSelected(item) }"
                        style="margin: 0px; border-radius:0px; width: 100%; border-width: 0px 0px 1px 0px; display: block; text-align: left;"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="dropdown">
                <button class="dropbtn btn-search advanced-search-buttons">
                  Provider Types
                </button>
                <div class="dropdown-content">
                  <div class="modal-content" style="max-height: 400px;">
                    <div
                      v-for="items in sortedProviderTypes"
                      v-if="items.array.length > 0"
                    >
                      <input
                        v-for="item in items.array"
                        v-on:click="
                          $store.commit('toggleProviderTypesParam', item)
                        "
                        type="button"
                        :value="item.name"
                        class="grid-item small-btn-search btn-search"
                        v-bind:class="{ selected: providerTypeSelected(item) }"
                        style="margin: 0px; border-radius:0px; width: 100%; border-width: 0px 0px 1px 0px; display: block; text-align: left;"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <hr style="margin-top:20px" />
        <displayAndSelect
          v-if="currentResults.length > 0"
          :providers="currentResults"
          title="Search"
          type="edit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import displayAndSelect from "../elements/displayAndSelect.vue";
import utils from "./utils.js";

export default {
  name: "provider-page",
  components: {
    displayAndSelect: displayAndSelect
  },
  data: function() {
    return {
      query: "",
      advancedSearchToggle: false,
      countrySearchQuery: "",
      sortedCapitalTypes: [],
      sortedProviderTypes: [],
      sortedDevCountries: [],
      sortedSectors: []
    };
  },
  computed: {
    ...mapGetters([
      "currentResults",
      "results",
      "capitalTypes",
      "providerTypes",
      "sectors",
      "devCountries",
      "getSelectedCapitalTypes",
      "getSelectedProviderTypes",
      "getSelectedCountries",
      "getSelectedSectors",
      "countrySelected",
      "sectorSelected",
      "capitalTypeSelected",
      "providerTypeSelected"
    ]),
    sortedDevCountriesBySearchQuery: function() {
      if (this.countrySearchQuery != "") {
        var filteredPropertyArray = this.sortedDevCountries.map(collection => {
          return {
            letter: collection.letter,
            array: collection.array.filter(item => {
              return (
                item.name
                  .toLowerCase()
                  .indexOf(this.countrySearchQuery.toLowerCase()) > -1
              );
            })
          };
        });
        return filteredPropertyArray;
      } else {
        return this.sortedDevCountries;
      }
    }
  },
  methods: {
    ...mapActions({
      fetchProvider: "fetchProviderForEdit"
    }),
    newProvider: function() {
      this.$store.commit("setCreateMode");
      this.$store.commit("createNewProvider");
      this.$router.push({ name: "provider" });
    },
    search: function() {
      this.$store.dispatch("search", { search_string: this.query });
      this.$store.commit("setPage", 0);
    },
    toggleAdvancedSearch() {
      this.advancedSearchToggle = !this.advancedSearchToggle;
      this.$store.commit("clearParam");
    }
  },
  mounted() {
    this.$store.commit("setNullMode");
    this.$store.commit("clearParam");
    this.$store.commit("setResults", []);
    this.$store.commit("setPage", 0);
    const alphabet = utils.alphabet();
    for (var letter of alphabet) {
      this.sortedCapitalTypes.push({
        letter: letter,
        array: utils.arrangeListByLetter(this.capitalTypes, letter)
      });
      this.sortedProviderTypes.push({
        letter: letter,
        array: utils.arrangeListByLetter(this.providerTypes, letter)
      });
      this.sortedDevCountries.push({
        letter: letter,
        array: utils.arrangeListByLetter(this.devCountries, letter)
      });
      this.sortedSectors.push({
        letter: letter,
        array: utils.arrangeListByLetter(this.sectors, letter)
      });
    }
  }
};
</script>

<style scoped>
.selected {
  color: lightgrey;
}

.dropbtn {
  cursor: pointer;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown-content .btn-search {
  border-radius: 0px;
}

.dropdown:hover .dropbtn {
  background-color: lightgrey;
}

.grid-container {
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  padding: 10px;
}

.grid-item {
  padding: 2px;
  font-size: 10px;
  text-align: center;
}

.small-btn-search {
  width: 100px;
}

.advanced-search-buttons {
  margin: 5px;
}

.btn-search {
  display: inline-block;
  padding: 4px 15px 6px 15px;
  border: solid 1px black;
  border-radius: 5px;
  background-color: white;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
}

.btn-search:hover {
  background-color: #eaeaea;
}

.search-field {
  display: inline-block;
}

hr {
  border-style: inset;
  size: 4px;
  color: black;
}

.modal-content {
  position: absolute;
  z-index: 1;
  padding-top: 200px;
  left: 4px;
  top: -5px;
  background-color: #fefefe;
  margin: auto;
  padding: 0px;
  border: 1px solid #888;
  max-height: 60vh;
  overflow: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/searchPage.vue